<template>
	<div>

		<breadcrumbs />


		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.company_info }}
							</h6>
							<div class="element-box">
								<generalForm />
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<userWidget :collapsed="true" :title="t.user.last_login" :filter="{ per_page: 10, short: 'lastLogin', direction: 'desc', loginDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss')}}" />
				<userWidget :collapsed="true" :title="t.last_activity" :filter="{ per_page:10, short: 'lastActivityAt', direction: 'desc', activityDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss') } }" />

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
    import userWidget from '@/components/user/widget/userWidget'
    import generalForm from '@/components/configuration/form/companyInfo'
    export default {
        name: 'companyInfo',
        components: {generalForm, userWidget},
        data () {
            return {
                t: this.$root.t
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/configuration/companyInfo.vue